import { render, staticRenderFns } from "./purchased_product.vue?vue&type=template&id=7763ba3a&scoped=true"
import script from "./purchased_product.vue?vue&type=script&lang=js"
export * from "./purchased_product.vue?vue&type=script&lang=js"
import style0 from "./purchased_product.vue?vue&type=style&index=0&id=7763ba3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763ba3a",
  null
  
)

export default component.exports